module.exports = __webpack_public_path__ + "static/media/right_arrow_green.2e181da6.svg";